import React from 'react';

/**
 * Screenshots on a saved item.
 *
 * Thumbnails that open the full image in a new tab rather than a lightbox:
 * someone triaging a rendering bug wants to zoom into a corner of it, and
 * the browser's own image viewer does that better than anything worth
 * building here.
 */
export default function AttachedShots({ shots }) {
  const list = Array.isArray(shots) ? shots.filter((shot) => shot && shot.url) : [];
  if (list.length === 0) return null;

  return (
    <div className="fb-seen">
      {list.map((shot, index) => (
        <a
          key={shot.id || shot.url}
          className="fb-seen__link"
          href={shot.url}
          target="_blank"
          rel="noopener noreferrer"
          title={shot.name || `Screenshot ${index + 1}`}
        >
          <img
            className="fb-seen__img"
            src={shot.url}
            alt={shot.name || `Screenshot ${index + 1} attached to this report`}
          />
        </a>
      ))}
    </div>
  );
}
